<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('bridge.title')"/>
        <div class="col-sm-12 my-2">
          <bridge-search
            @search="fetchBridges"
          />
          <Transition name="fade">
            <div class="col-sm-12 my-2">
              <bridge-list
                :bridges="results"
                @row-clicked="rowClicked"
              />
            </div>
          </Transition>
         <bridge-details v-if="item" :item="item" @close="item = null" @inspection="startInspection"/>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import BridgeSearch from "@/components/bridge/BridgeSearch";
import BridgeList from "@/components/bridge/BridgeList";
import BridgeDetails from "@/components/bridge/BridgeDetails";
import {mapHelper} from "@/components/mixins/MapMixin";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'Bridges',
    components: {Navbar, BridgeDetails, BridgeList, BridgeSearch},
    mixins: [restApi, mapHelper],

    data: function () {
        return {
            results: [],
            loading: false,
            lastSearchedParams: null,
            item: null,
            mapHelper
        }
    },

    methods: {

        startInspection(bridge) {
          this.$emit('startInspection', 'inspectionWizard', 'bridge', this.item)
        },

        fetchBridges: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.bridgeUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            for (let i = 1; i <= this.results.length; i++) {
                this.results[i].id = i
            }
            this.loading = false
        },
        rowClicked: function (item) {
            this.item = item
        }
    }
}
</script>
